const colors = {
  primary: ['#F47B22', '#F58633', '#F69248', '#F89E5D', '#F9AA70'],
  secondary: ['#221E1F', '#34393A', '#4B4F51', '#626668', '#626668'],
};
export default colors;
